/**
 * 圏外中のGPSを端末に貯めるキュー（gps_offline_buffer）。
 * 打刻キュー（syncQueue）と同じ考え方で、電波が戻ったら /gps/location/bulk へまとめて送る。
 * 貯めるのは約5分間隔・最大1000点（約3日分）。古い分から捨てる。
 */
export interface PendingGpsPoint {
  latitude: number;
  longitude: number;
  accuracy?: number;
  speed?: number;
  heading?: number;
  vessel_id?: string;
  /** 測位した実時刻（ISO）。サーバーはこの時刻で記録する */
  recorded_at: string;
}

const KEY = 'catms_gps_queue';
const MAX_POINTS = 1000;
/** 圏外中の間引き間隔。この時間内の連続測位は貯めない */
const MIN_INTERVAL_MS = 4.5 * 60_000;

function load(): PendingGpsPoint[] {
  try { return JSON.parse(localStorage.getItem(KEY) ?? '[]') as PendingGpsPoint[]; }
  catch { return []; }
}
function save(q: PendingGpsPoint[]): void {
  try { localStorage.setItem(KEY, JSON.stringify(q)); } catch { /* 容量超過などは無視 */ }
}

/** 測位を貯める。直前の点から間隔が短すぎるものは捨てる（圏外中は1分ごとに呼ばれるため） */
export function gpsEnqueue(p: PendingGpsPoint): void {
  const q = load();
  const last = q[q.length - 1];
  if (last && Date.parse(p.recorded_at) - Date.parse(last.recorded_at) < MIN_INTERVAL_MS) return;
  q.push(p);
  save(q.length > MAX_POINTS ? q.slice(-MAX_POINTS) : q);
}

export function gpsQueuePeek(n: number): PendingGpsPoint[] {
  return load().slice(0, n);
}

export function gpsQueueRemove(n: number): void {
  save(load().slice(n));
}

export function gpsQueueCount(): number {
  return load().length;
}
